import { render, staticRenderFns } from "./IframeVideoPlayer.vue?vue&type=template&id=b1c1f9e8&scoped=true&"
import script from "./IframeVideoPlayer.vue?vue&type=script&lang=ts&"
export * from "./IframeVideoPlayer.vue?vue&type=script&lang=ts&"
import style0 from "./IframeVideoPlayer.vue?vue&type=style&index=0&id=b1c1f9e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1c1f9e8",
  null
  
)

export default component.exports